import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const Ocho = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX'], marginTop: '3%'}}>SWOT</Paragraph>
        <Text className='BaseText2'>The strengths, weaknesses, opportunities, and threats of iMoAge can be summarized in the SWOT matrix which it is useful to understand what can be improved in our product to reduce the weaknesses and threats that can be imposed by the industry. Our SWOT analysis is shown in the following picture.</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-32.png'/>
          <p><b>Fig. 7.</b> iMoAge SWOT analysis.</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Ocho;
